module.exports = __webpack_public_path__ + "media/images/accountSection__profileImage-6d229780f517033a459144c316d2bc1c.png";